'use client';

import * as React from 'react';
const MuiLicenseInfoContext = /*#__PURE__*/React.createContext({
  key: undefined
});
if (process.env.NODE_ENV !== "production") MuiLicenseInfoContext.displayName = "MuiLicenseInfoContext";
export default MuiLicenseInfoContext;